import React from 'react';
import { ICONS } from '../constants';
import SupportEmailLink from './SupportEmailLink';

interface HandoffGateProps {
  handoffTopic: string | null;
  onLoginClick: () => void;
}

const HandoffGate: React.FC<HandoffGateProps> = ({ handoffTopic, onLoginClick }) => {
  return (
    <div className="min-h-screen bg-click-dark flex flex-col items-center justify-center p-4 relative overflow-hidden">
      <div className="absolute inset-0 bg-lab-pattern" />
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-click-red/10 blur-[120px] rounded-full" />
      <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-click-cyan/5 blur-[100px] rounded-full" />

      <div className="relative z-10 text-center max-w-lg">
        <h1 className="text-2xl font-display font-bold text-white mb-6">כמעט שם</h1>

        {handoffTopic && (
          <div className="mb-6 p-4 bg-click-card/80 border border-click-border rounded-xl text-right">
            <p className="text-sm text-gray-400 mb-1">מה שהזנת:</p>
            <p className="text-white font-bold line-clamp-2 break-words">
              {handoffTopic.length > 80 ? `${handoffTopic.slice(0, 80)}...` : handoffTopic}
            </p>
            <p className="text-xs text-gray-500 mt-2">ותמונה הועלתה</p>
          </div>
        )}

        <p className="text-lg text-gray-200 mb-8 leading-relaxed">
          רק תירשם שניה בחינם כדי שתוכל להמשיך ושנוכל לשמור לך את הפרויקט
        </p>

        <button
          onClick={onLoginClick}
          className="bg-click-red text-white font-bold text-lg py-4 px-12 rounded-xl hover:bg-white hover:text-click-red transition-all duration-300 shadow-[0_0_30px_rgba(255,0,60,0.3)]"
        >
          <span className="flex items-center justify-center gap-3">
            <ICONS.LogIn className="w-5 h-5" />
            הרשם בחינם
          </span>
        </button>
      </div>
      <div className="absolute bottom-6 left-0 right-0 text-center z-10">
        <SupportEmailLink className="text-xs text-gray-500 hover:text-gray-300 transition-colors" showEmail />
      </div>
    </div>
  );
};

export default HandoffGate;
